import { FundWithDetailsEntity } from '../../Entities/Fund.WithDetails.Entity';
import { FundBtnHandlers } from './Fund.FrontEnd.Btn.Handlers';
import { FundWithDetailsTxApiCalls } from './Fund.WithDetails.FrontEnd.Tx.Api.Calls';

export class FundWithDetailsBtnHandlers extends FundBtnHandlers {
    protected static _Entity = FundWithDetailsEntity;
    protected static _TxApiCalls = FundWithDetailsTxApiCalls;

}